import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import * as actions from "../actionCreator";
import { GlobalApplicationState } from "globalApplicationState";

import { CommentNotificationSettings } from "modules/settings/models";
import DialogSelectField from "./common/dialogSelectField";
import DialogSwitchField from "./common/dialogSwitchField";

import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SMSConsentStatus } from "modules/users";


class Notifications extends React.Component<PropsWithRedux, ComponentState> {
  constructor(props: PropsWithRedux) {
    super(props);

    this.state = {
      hasChanges: false,
      chatEnabled: props.userSettings.chatEnabled,
      commentNotificationSettings: props.userSettings.commentNotificationSettings,
      smsConsentStatus: props.userSettings.smsConsentStatus,
      preferredSMSPhone: props.userSettings.preferredSMSPhone,
      sendNotificationsWhenAuthor: props.userSettings.sendNotificationsWhenAuthor,
    };
  }

  public componentDidUpdate(prevProps: PropsWithRedux) {
    if (this.props.show && prevProps.show !== this.props.show)
      this.onReset();
  }

  public render() {
    const { commentsEnabled, notificationSettings } = this.props;
    const commentNotificationsEnabled = notificationSettings.postCommentCreatedTeamsAttempt.toggle || notificationSettings.postCommentCreatedMobileAttempt.toggle;
    const showCommentOptions = commentsEnabled && commentNotificationsEnabled;

    return (
      <Drawer anchor="right" open={this.props.show} onClose={this.onSave} classes={{ paper: "my-profile-dialog-drawer" }} className="my-profile-dialog">
        <Paper square elevation={0} className="my-profile-dialog-header">
          <IconButton onClick={this.onSave} size="large">
            <ArrowBackIcon />
          </IconButton>
          <div>Notifications</div>
        </Paper>
        {showCommentOptions &&
          <>
            <DialogSwitchField
              label="Notify me of comments for posts I've published or authored"
              value={this.state.sendNotificationsWhenAuthor}
              onChange={this.onChangeSendNotificationsWhenAuthor}
            />
            <DialogSelectField
              label="Notify me of comments on"
              options={[
                { key: "accessible", text: "All posts I have access to", type: "item" },
                { key: "engaged", text: "All posts I have commented on or reacted to", type: "item" },
                { key: "subscribed", text: "All posts I'm subscribed to", type: "item" },
                { key: "none", text: "None", type: "item" }
              ]}
              value={this.state.commentNotificationSettings}
              onChange={this.onChangeCommentNotificationSettings}
            />
          </>
        }
        {this.props.chatEnabled &&
          <DialogSwitchField
            label="Receive chat notifications"
            description="Get notified whenever you receive a new chat message"
            value={this.state.chatEnabled}
            onChange={this.onChangeChatEnabled}
          />
        }
        <Divider light />
        <div className="reset-dialog">
          <Button variant="text" color="primary" onClick={this.onReset}>Reset notifications</Button>
        </div>
      </Drawer>
    );
  }


  private onSave = () => {
    if (this.state.hasChanges)
      this.props.saveUserSettings({
        chatEnabled: this.state.chatEnabled,
        commentNotificationSettings: this.state.commentNotificationSettings,
        smsConsentStatus: this.state.preferredSMSPhone !== this.props.userSettings.preferredSMSPhone ? SMSConsentStatus.Unknown : this.state.smsConsentStatus,
        preferredSMSPhone: this.state.preferredSMSPhone,
        sendNotificationsWhenAuthor: this.state.sendNotificationsWhenAuthor,
      });
    this.props.onClose();
  }


  private onChangeChatEnabled = (event, checked) => {
    this.setState({ hasChanges: true, chatEnabled: checked });
  }

  private onChangeCommentNotificationSettings = (event) => {
    this.setState({ hasChanges: true, commentNotificationSettings: event.target.value });
  }

  private onChangeSendNotificationsWhenAuthor = (event, checked) => {
    this.setState({ hasChanges: true, sendNotificationsWhenAuthor: checked });
  }

  private onReset = () => {
    this.setState({
      hasChanges: false,
      chatEnabled: this.props.userSettings.chatEnabled,
      commentNotificationSettings: this.props.userSettings.commentNotificationSettings,
      smsConsentStatus: this.props.userSettings.smsConsentStatus,
      preferredSMSPhone: this.props.userSettings.preferredSMSPhone,
      sendNotificationsWhenAuthor: this.props.userSettings.sendNotificationsWhenAuthor,
    });
  }
}


interface ComponentProps {
  show: boolean;
  onClose: () => void;
}

interface ComponentState {
  hasChanges: boolean;
  chatEnabled: boolean;
  commentNotificationSettings: CommentNotificationSettings;
  smsConsentStatus: SMSConsentStatus;
  preferredSMSPhone: string;
  sendNotificationsWhenAuthor: boolean;
}

const connector = connect(
  (state: GlobalApplicationState, ownProps: ComponentProps) => ({
    ...ownProps,
    chatEnabled: state.settings.clientSettings.chatEnabled,
    userSettings: state.profile.userSettings!,
    commentsEnabled: state.settings.clientSettings.commentSystem.enabled,
    notificationSettings: state.settings.notificationSettings.settings
  }),
  {
    saveUserSettings: actions.saveUserSettings
  }
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(Notifications);